.loading-container {
    padding-top: 24px;
    width: calc(100% - 8px);
}
